import React, { useState, useCallback } from 'react'
import cx from 'classnames'
import { Back, Button, Icon } from 'react-wot-bootstrap'
import PropTypes from 'prop-types'
import SOUNDS from 'react-wot-bootstrap/lib/sounds'

import Reasons from '../Reasons/Reasons'

import { LEAVING_CLAN, COOLDOWN, LEAVING_BUTTON, CANCEL_BUTTON, CLOSE_BUTTON } from './constants'
import styles from './ClanLeavingLayout.scss'

const ClanLeavingLayout = ({ clan, leaveClan, openClanManagement, clanEntranceCooldown }) => {
    const [reasons, setReasons] = useState([])

    const handleChangeReasons = useCallback((value) => {
        setReasons(value)
    }, [])

    return (
        <div className={styles.base}>
            <header className={styles.closeButton}>
                <Back caption={CLOSE_BUTTON} type="close" side="right" onClick={openClanManagement} />
            </header>
            <main className={styles.main}>
                <div className={styles.title}>
                    {LEAVING_CLAN}
                    <span style={{ color: clan.color }}>{` [${clan.tag}]`}</span>
                </div>
                <Reasons onChange={handleChangeReasons} />
                <div className={styles.warning}>
                    <Icon glyph="warning" />
                    <div className={styles.warningText}>
                        {COOLDOWN(Math.floor(clanEntranceCooldown / 3600))}
                    </div>
                </div>
                <div className={styles.buttons}>
                    <Button mixClassName={cx(styles.button, styles.button__leaving)} onClick={() => {
                        leaveClan(reasons)
                    }}
                    >
                        {LEAVING_BUTTON}
                    </Button>
                    <Button
                        mixClassName={styles.button}
                        type="secondary"
                        onClick={openClanManagement}
                        buttonClickSoundId={SOUNDS.CLICK}
                    >
                        {CANCEL_BUTTON}
                    </Button>
                </div>
            </main>
        </div>
    )
}

ClanLeavingLayout.propTypes = {
    clan: PropTypes.shape({
        color: PropTypes.string,
        emblem: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        isClanAcceptableForAutoJoining: PropTypes.bool.isRequired,
        isRecruitingOpened: PropTypes.bool.isRequired,
        languages: PropTypes.arrayOf(PropTypes.string).isRequired,
        membersCount: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        strongholdLevel: PropTypes.number.isRequired,
        tag: PropTypes.string.isRequired,
    }),
    leaveClan: PropTypes.func.isRequired,
    openClanManagement: PropTypes.func.isRequired,
    clanEntranceCooldown: PropTypes.number.isRequired,
}

export default ClanLeavingLayout



// WEBPACK FOOTER //
// ./containers/ClanLeaving/components/ClanLeavingLayout/ClanLeavingLayout.jsx